import React, { useEffect } from 'react';
import Title from "../components/Title";
import Card from '../components/Card';
import TimelineUiUx from '../components/TimelineUiUx';
import SliderCodify from '../components/SliderCodify';
import Collapse from '../components/Collapse'
import ServiceCard from '../components/ServiceCard';
import Contact from '../components/Contact';

import '../styles/lines.css'
const services = [
    {
        title: 'Customer Acquisition & Retention',
        description: 'An attractive, functional and easy to use UX/UI will amaze your users and solve their problems effectively. These positive experiences will not only drive people to your product, but it will also keep them using it.',
        icon: <img src="/Group-3303.svg" alt="icon" />,
    },
    {
        title: 'Reduced Cost',
        description: 'A well-designed product will require less training, documentation and development, both now and in the future. This will allow your team to focus on developing the business instead of correcting false assumptions or confusing navigation that gets the user stuck.',
        icon: <img src="/Group-3309.svg" alt="icon" />,
    },

];
const faqs = [
    { question: "Top Talent", answer: "We work with the best and brightest in tech talent to ensure you get high-quality tech architecture. For each developer we onboard, we go through at least 100 candidates. Once onboarded our employees stay long-term, meaning they have a deep knowledge of the company and the processes we use." },
    { question: "Proven Track Record", answer: "With over 80 successful projects delivered, our product, UX/UI, and software development teams consistently turn ideas into impactful digital solutions. Our experience and expertise ensure that your project is not just completed but exceeds expectations, driving real results for your business." },
    { question: "Business Mindset", answer: "As ex-startup founders with a corporate background, we have experienced many of the struggles on both sides. We know there is more to a successful product than technology, so we will always look at your product from a business standpoint." },
    { question: "User-Centric Approach", answer: "We value your end-user above specifications. We take the time to understand your client’s needs and desires. The result is a product they will actually use." },
    { question: "Lean Product Development", answer: "We have learned lean product development through building startups from the ground up with very few resources. When you build a product with us it will always be streamlined to the most important features for your user." },
    { question: "Cross-Industry Experience", answer: "Our team brings a wealth of experience across multiple industries, from fintech and healthcare to e-commerce and entertainment. This diverse expertise allows us to adapt and apply best practices from various sectors to your project, ensuring innovative solutions tailored to your unique business needs." },
    { question: "Dedicated In-House Team", answer: "Our projects are handled by a dedicated in-house team, ensuring consistent communication, seamless collaboration, and full alignment with your vision. This approach guarantees that the same experts who start your project see it through to completion, maintaining quality and focus every step of the way." },
];
const servicesCards = [

    {
        title: 'Product Scope',
        description: 'A structured 15 day process to align your product vision with your business goals.',
        link: '/product-scope',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 64 66" fill="none"><path id="Vector" d="M32.0001 63.5413L62.1108 25.6371L47.0555 2.45874M32.0001 63.5413L1.88933 25.6371L16.9447 2.45874M32.0001 63.5413L47.0555 2.45874M32.0001 63.5413L16.9447 2.45874M16.9447 2.45874L47.0555 2.45874M60.6231 25.3059H1.88916" stroke="#0FA4EA" stroke-width="3.44505" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        ),
    },
    {
        title: 'MVP Builder',
        description: 'Go to the market quickly with a high-quality Minimum Viable Product.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 64 74" fill="none"><path id="Vector" d="M1.81787 54.3569L32.0015 2.08948L62.1819 54.3569M62.1819 54.3569L32.0015 36.9343L1.81788 54.4059L32.0015 71.7793L62.1819 54.3569ZM31.6084 2.08948L31.6084 71.9106" stroke="#F6D200" stroke-width="3.25832" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        ),
        link: '/mvp-builder',
    },
    {
        title: 'Dedicated Teams',
        description: 'Build your product with a dedicated team of developers.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.8873 22.749C25.3242 22.749 20.8143 18.2392 20.8143 12.6761C20.8143 7.1129 25.3242 2.60307 30.8873 2.60307C36.4505 2.60307 40.9603 7.1129 40.9603 12.6761C40.9603 18.2392 36.4505 22.749 30.8873 22.749ZM18.2113 12.6761C18.2113 19.6768 23.8865 25.3521 30.8873 25.3521C37.8881 25.3521 43.5634 19.6768 43.5634 12.6761C43.5634 5.67526 37.8881 0 30.8873 0C23.8865 0 18.2113 5.67526 18.2113 12.6761ZM21.1879 29.3672C21.437 28.9718 21.8689 28.7324 22.3329 28.7324H22.8842H38.5967H39.0246C39.4939 28.7324 39.9299 28.9772 40.1775 29.3798L57.7252 57.9062C57.9852 58.3288 57.998 58.8606 57.7585 59.2955C57.5191 59.7303 57.0651 60 56.5724 60H38.5967C38.104 60 37.6501 59.7304 37.4106 59.2957L30.5846 46.9029L23.5091 59.3133C23.2669 59.7381 22.8184 60 22.3329 60H4.35721C3.86185 60 3.40584 59.7275 3.16747 59.2889C2.9291 58.8504 2.94624 58.3156 3.21218 57.8936L21.1879 29.3672ZM6.82959 57.2588L22.5487 32.3135L29.0455 44.1087L21.5483 57.2588H6.82959ZM39.3948 57.2588L32.1644 44.132L38.8468 32.4112L54.1315 57.2588H39.3948ZM30.6253 41.3377L36.2492 31.4736H25.1921L30.6253 41.3377Z" fill="#EF713F"></path></svg>
        ),
        link: '/dedicated-teams',
    },
    {
        title: 'Custom Software Development',
        description: 'Lean frameworks applied to your vision to create an innovative custom software solution.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M30.6964 0C30.3263 0 29.9745 0.161073 29.7326 0.441264L4.70222 29.44C4.28676 29.9213 4.29011 30.6354 4.71006 31.1128L29.7405 59.5677C29.9817 59.842 30.3291 59.9994 30.6944 60C31.0597 60.0006 31.4076 59.8442 31.6497 59.5708L44.1649 45.4339L44.1702 45.4279L56.6854 31.1097C57.1029 30.6322 57.1051 29.9201 56.6906 29.44L31.6602 0.441264C31.4184 0.161073 31.0666 0 30.6964 0ZM53.5793 29.7323L31.9696 38.0254V4.69666L53.5793 29.7323ZM29.4233 4.69666V38.0254L7.81357 29.7323L29.4233 4.69666ZM10.0367 33.3129L27.0832 39.8548L18.56 43.0023L10.0367 33.3129ZM20.3622 45.0511L29.4233 41.705V55.3518L20.3622 45.0511ZM31.9696 55.368V41.7175L41.0331 45.1301L31.9696 55.368ZM34.2794 39.8663L42.834 43.0874L51.3887 33.3004L34.2794 39.8663Z" fill="#49B0B0"></path></svg>
        ),
        link: '/custom-software-development',
    },
    {
        title: 'AI Development & Enablement',
        description: 'We leverage ML and Generative AI strategically to ensure your business is future-ready.',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 82 95" fill="none"><path d="M41.5397 47.4397L42.34 2.30857L22.186 36.5125L41.5397 47.4397Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.30519 70.7737L41.6313 47.5904L22.3741 36.7178L2.30519 70.7737Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M41.2044 70.0928L41.6061 47.6716L2.35571 70.8024L41.2044 70.0928Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M41.2504 70.3598L40.8487 92.7809L2.40173 71.0693L41.2504 70.3598Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M40.9963 70.4531L40.5946 92.8743L79.8451 69.7435L40.9963 70.4531Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M41.2847 47.4861L42.0841 2.35303L61.0362 35.8519L41.2847 47.4861Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M79.819 69.442L41.307 47.69L60.9685 36.0999L79.819 69.442Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M40.9514 70.1871L41.3528 47.7638L79.7981 69.4783L40.9514 70.1871Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M61.1053 36.0356L41.0675 70.1285L22.2279 36.7393L61.1053 36.0356Z" stroke="#7B5AB4" stroke-width="2.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        ),
        link: '/service-ai',
    },
];
const dataSlider = [
    {
      title: "Information Architecture",
      content:
        "During the wireframing phase, we focus on a low-fidelity design, the minimum graphic representation of the product with just the most essential elements and the content. This way, it is easy to iterate until the optimal structure is reached without losing time with details.",
      image: "info_ar.webp",
    },
    {
      title: "UI Mockups",
      content:
        "Our mockup phase starts right after the UX and the brand are defined. The output is a high-fidelity design already reflecting the aesthetics approach, from the product’s color schemes, visual style and typography.",
      image: "ui_mo.webp",
    },

    {
      title: "Clickable Prototype",
      content:
        "The clickable prototype is a non-functional prototype meant to simulate users’ interaction. The experience of using the clickable prototype is very much like the final product itself, this is the adequate phase to test the information architecture and UX.",
      image: "clickable-prototype.webp",
    },
    {
      title: "Brand Brief",
      content:
        "In some cases, there is not a Brand Rationale or a strong branding in place when we start, so in this case, we go through the brand brief to try to understand the brand values that should be reflected in the UI and aesthetics of the product.",
      image: "Brand-Brief.png.webp",
    },
    {
        title: "Key BPMN",
        content:
          "Optional: BPMN (Business Process Model & Notation) is a flow chart method that models the steps of a planned business process from end to end. This is usually needed at this stage when we have complex workflows. We design the key flows to be sure that we’re not missing any important detail in the main flows, and that we’re in sync with the client’s vision.",
        image: "bpmn.jpg.webp",
      },

  ];
const UiUX = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            <div className='mt-32'>
                <img src="/bg-prop-4-right.svg" alt="codify" className="absolute  top-0 right-0  -z-10" />
                <Title
                    title="UX/UI"
                    description="Design an engaging product that is easy-to-use, attractive and functional"
                />
            </div>
            <div className='relative bg-[#f1f7fb] shadow-2xl overflow-hidden'>

                <div className=" grid  gap-8  z-10  grid-cols-1 flex justify-center place-items-center ">

                    <h1 className="mt-24 text-3xl sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins">
                        Key Benefits
                    </h1>
                    <div className="w-5/6  gap-4 grid  grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 justify-center place-items-center">
                        {services.map((service, index) => (
                            <Card key={index}
                                title={service.title}
                                description={service.description}
                                icon={service.icon}
                            />
                        ))}
                    </div>
                </div>
                <div>
                    <h1 className="mt-24 text-3xl sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins text-center bg-gray-100 p-4 rounded-lg shadow-md">
                        How it works
                    </h1>
                    <TimelineUiUx />
                </div>
                <div className="mt-16">
                    <h1 className="text-3xl sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins text-center">
                    Detailed deliverables
                    </h1>
                    <SliderCodify data={dataSlider}/>
                </div>
                <div className="mt-16">
                    <h1 className="text-3xl sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins text-center">Why us?</h1>
                    <div className=" mt-16 grid  gap-8  z-10  grid-cols-1 flex justify-center place-items-center ">
                        {faqs.map((faq, index) => (
                            <Collapse key={index} title={faq.question}>
                                {faq.answer}
                            </Collapse>
                        ))}
                    </div>
                </div>
                <div className='relative '>
                <h1 className="mt-16 text-3xl sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins text-center">Other services we provide</h1>
                <div className=" xl:pl-20 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 mt-20 relative z-10">
                    {servicesCards.map((servicesCards, index) => (
                        <ServiceCard key={index}
                            link={servicesCards.link}
                            title={servicesCards.title}
                            description={servicesCards.description}
                            icon={servicesCards.icon}
                        />
                    ))}
                </div>

            </div>
            </div>
          
           
           
            <div className="mt-24 xl:mt-2">
                <div>
                    <Contact />
                    <div className='mt-48' />
                </div>
            </div>
        </div>
    );
};

export default UiUX;
